// Public share-view client. All "view a shared conversation" reads go
// through the analysis-agent because it owns the AG-UI message conversion
// (pydantic-ai → @ag-ui/core); the conversations service stores the raw
// turn data but doesn't know how to reshape it for the frontend renderer.

import type { Message } from "@ag-ui/core";
import { apiClient, ApiError, isApiError } from "~/utils/apiClient";

const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

export const sharedConversationApiPath = (token: string) =>
  `${VITE_ANALYSIS_AGENT_API}/shares/${token}`;

export interface SharedConversationView {
  display_name: string;
  owner_display_name: string | null;
  created_at: string;
  messages: Message[];
}

// Returned 404 → null so callers can render the empty-state without
// catching ApiError themselves. Other errors propagate.
export async function getSharedConversation(
  token: string,
  options?: { signal?: AbortSignal }
): Promise<SharedConversationView | null> {
  try {
    return await apiClient<SharedConversationView>(sharedConversationApiPath(token), {
      signal: options?.signal,
    });
  } catch (err) {
    if (isApiError(err) && (err as ApiError).status === 404) return null;
    throw err;
  }
}
